var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("user-header", {
    attrs: {
      infoObj: _vm.infoObj
    }
  }), _c("div", [_c("a-card", [_c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule,
      "label-col": {
        span: 3
      },
      "wrapper-col": {
        span: 10
      }
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("离职类型"),
      prop: "resignType"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("离职类型")
    },
    model: {
      value: _vm.dataFrom.resignType,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignType", $$v);
      },
      expression: "dataFrom.resignType"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("被动离职")))]), _c("a-select-option", {
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("主动离职")))])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("离职原因"),
      prop: "resignReason"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("离职原因"),
      allowClear: "",
      maxLength: 100
    },
    model: {
      value: _vm.dataFrom.resignReason,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignReason", $$v);
      },
      expression: "dataFrom.resignReason"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("所属部门")
    }
  }, [_c("a-input", {
    attrs: {
      value: _vm.$t("部门1"),
      readOnly: true
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日期"),
      prop: "resignAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate()
    },
    model: {
      value: _vm.dataFrom.resignAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "resignAt", $$v);
      },
      expression: "dataFrom.resignAt"
    }
  })], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("下级归属至"),
      prop: "type"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.type,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type", $$v);
      },
      expression: "dataFrom.type"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("上级直辖")) + " ")]), _c("a-radio", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("指定组织/人")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("续期分配方式"),
      prop: "type2"
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.dataFrom.type2,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "type2", $$v);
      },
      expression: "dataFrom.type2"
    }
  }, [_c("a-radio", {
    attrs: {
      value: "1"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("指定业务员")) + " ")]), _c("a-radio", {
    attrs: {
      value: "2"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("分配孤儿单")) + " ")])], 1)], 1), _c("a-form-model-item", {
    attrs: {
      "wrapper-col": {
        span: 14,
        offset: 4
      }
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("保存")) + " ")])], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };